<template>
  <div class="layout calculations">
    <m-table-settings
      v-model="tableData.settingsModal"
      :columns="tableData.columns"
      :disabled-columns="tableData.disabledColumns"
      :default-disabled-columns="tableData.defaultDisabledColumns"
      with-categories
      @submit="submitTableSettings"
    />

    <div class="layout-header">
      <div class="layout-title">Расчеты</div>

      <div class="layout-header-actions">
        <!--
      <div class="layout-header-action">
        <c-button
          :icon="{
            icon: 'bookmark',
            activeColor: 'white'
          }"
          :tooltip="{
            text: 'Добавить в закладки',
            activeText: 'Убрать из закладок'
          }"
          activeColor="blue"
          :active="bookmark"
          @click="bookmark = !bookmark"
        />
      </div>

      <div class="layout-header-action">
        <c-button
          responsive
          label="Управление фильтрами"
          icon="filter"
          @click="manageFiltersModal = 'list'"
        />
      </div>
      -->

        <div class="layout-header-action" v-if="canEdit">
          <c-button
            class="calculations__actions__new-calc-desktop"
            label="Новый расчет"
            :icon="{
              icon: 'plus',
              color: 'white',
            }"
            color="blue"
            @click="$router.push('/calculation/production')"
          />

          <c-button
            class="calculations__actions__new-calc-mobile"
            responsive
            label="Новый расчет"
            :icon="{
              icon: 'plus',
              color: 'white',
            }"
            color="blue"
            @click="$router.push('/calculation/production')"
          />
        </div>
      </div>
    </div>

    <div class="calculations__filters">
      <m-manage-filters
        :modal="manageFiltersModal"
        store-module="calculations"
        @close="manageFiltersModal = null"
        @applyFilters="applyFilters"
      />

      <b-row class="calculations__filters-row" cols-md="12" cols-lg="12" cols-xs="2" align-v="end">
        <b-col class="calculations__filters-col mb-4" md="8" xl="5" lg="4" xs="2">
          <c-input-2
            v-model="filters.branches"
            class="documents-report-filters__item documents-report-filters__filial"
            :type="'select'"
            label="Филиал"
            :checkbox-value="filters.branchesReverse"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-tooltip="{
              disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
              activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
              notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
            }"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="branches2"
            @checkboxChange="filters.branchesReverse = $event"
          />
<!--
          <c-input
            v-model="filters.branches"
            type="select"
            label="Филиал"
            :checkbox="true"
            :checkbox-value="filters.branchesReverse"
            checkbox-type="icon"
            :checkbox-tooltip="{
              disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
              activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
              notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
            }"
            :disabled="branches2.length === 0"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="branches2"
          />-->
        </b-col>

        <b-col lg="3" md="4" xs="2" class="calculations__filters-col mb-4">
          <c-input
            ref="period"
            v-model="filters.period"
            label="Период"
            placeholder="00.00.0000 - 00.00.0000"
            :clearable="true"
            type="period"
            icon="calendar"
            :icon-right="true"
          />
        </b-col>

        <!--
      <b-col lg="2" md="3" xs="2"
        class="calculations__filters-col mb-4 d-flex justify-content-md-center align-items-center">
        <c-switcher
          label="Только проблемные"
          class="calculations__filters-troubles"
          v-model="filters.onlyTroubles"
        />
      </b-col>
    -->

        <b-col xl="2" lg="3" md="4" xs="2" class="calculations__filters-col mb-4">
          <c-select v-model="filters.shift" label="Смена" :items="shifts" />
        </b-col>

        <b-col col class="calculations__filters-col" offset-lg="9" offset-md="0" lg="3" md="5">
          <div class="calculations__filters-actions mb-4 mt-2">
            <c-button
              label="Применить"
              size="large"
              color="blue"
              class="calculations__filters-actions-item calculations__filters-actions-item-apply"
              @click="submitFilters"
            />

            <c-button
              label="Сбросить"
              size="large"
              class="calculations__filters-actions-item calculations__filters-actions-item-reset"
              @click="resetFilters"
            />
          </div>
        </b-col>
      </b-row>
    </div>

    <div class="calculations__content">
      <div class="calculations__charts-wrapper" :class="{ 'calculations__charts-wrapper_active': chartsActive }">
        <div class="layout__hr calculations__charts-wrapper-hr-top"></div>

        <s-charts v-if="showCharts" class="calculations-charts" />

        <div class="layout__hr calculations__charts-wrapper-hr-bottom"></div>
      </div>

      <div class="calculations__settings">
        <div v-if="!isLoadingTable" class="calculations__summary">
          <div class="calculations__summary-item">
            Начислено/выплачено производству:
            <span>{{ totalSumProduction.toLocaleString() }} ฿</span>
            /
            <span> {{ totalPaidProduction.toLocaleString() }} ฿ </span>
          </div>

          <div class="calculations__summary-item">
            Н/в доставке:
            <span>{{ totalSumDriver.toLocaleString() }} ฿</span>/<span>{{ totalPaidDriver.toLocaleString() }} ฿</span>
          </div>
        </div>

        <div v-if="!isLoadingTable" class="calculations__actions">
          <div class="calculations__actions-item">
            <c-button-2
              icon="chart"
              :active="!chartsActive"
              :responsive="true"
              :label="chartsActive ? 'Скрыть графики' : 'Показать графики'"
              size="small"
              @click="toggleCharts"
            />
          </div>

          <div class="calculations__actions-item">
            <c-button
              :responsive="true"
              :icon="{ icon: 'filter-drop', color: 'secondary' }"
              label="Сбросить фильтры столбцов"
              size="small"
              @click="resetFiltersColumns"
              :disabled="this.tableData.activeFilteredColumns.length==0"
            />
          </div>

          <div class="calculations__actions-item">
            <c-button responsive icon="cog" label="Настроить столбцы" @click="tableData.settingsModal = true" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isLoadingTable" class="employees-list__table">
      <c-data-table
        ref="table"
        :sorted-column="tableData.sortedColumn"
        :data="tableData"
        :canAllDelete="canAllDelete"
        :canDeleteFiilals="canDeleteFiilals"
        :disabled-columns="tableData.disabledColumns"
        :levels="tableData.levels"
        :enabled-fields="enabledFields"
        :empty-records-label="'Записи не найдены'"
        :filtered-columns="tableData.filteredColumns"
        :active-filtered-columns="tableData.activeFilteredColumns"
        :reference-list="referenceFilterList"
        @sortedEvent="refreshTable"
        @getReferenceValues="setColumnReferenceFilterList"
        @setLevelsDataTable="setLevelsDataTable"
        @reset-column-filters="tableData.activeFilteredColumns = []"
        @remove-column-filter="onColumnFilterRemove"
        @set-column-filter="onSetColumnFilter"
        @set-column-filter-by-index="onSetColumnFilterByIndex"
        @disable-column-sorted-flag="onDisableColumnSortedFlag"
        @change-sorting-column="onSortingColumnChange"
      />
      <c-loader v-if="isLoadingData" label="Загрузка данных" :active="isLoadingData" height="150" />
      <transition name="fade">
        <ItemsCount
          :shown-items-count="recordsCount"
          :total-items-count="totalRows"
        />
      </transition>
    </div>
    <c-loader v-if="isLoadingTable" label="Производится расчёт" :active="isLoadingTable" height="500" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import queryString from "query-string";
import VueCookies from "vue-cookies";
import Vue from "vue";

import TableSettingsModal from "@/components/modals/table-settings";
import ManageFiltersModal from "@/components/modals/manage-filters";

import DataTable from "@/components/data-table";
import Button from "@/components/controls/button";
import Button2 from "@/components/controls2/Button";
import Charts from "@/pages/calculations/Charts";
import Input from "@/components/controls2/Input";

import Select from "@/components/controls/select";
import Loader from "@/components/loader";
import ItemsCount from "@/components/display-shown-items-count.vue";


const exceptTooltip = {
  disabledText: "Фильтр по всем значениям в справочнике, кроме выбранных",
  activeText: "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
  notActiveText: "Включить фильтр по всем значениям в справочнике, кроме выбранных",
};

Vue.use(VueCookies);

export default {
  name: "calculations",

  components: {
    "c-input-2": Input,
    "c-button": Button,
    "c-button-2": Button2,
    "c-input": Input,
    "c-loader": Loader,
    "c-select": Select,
    "c-data-table": DataTable,
    "s-charts": Charts,
    "m-table-settings": TableSettingsModal,
    "m-manage-filters": ManageFiltersModal,
    ItemsCount,
  },

  props: ["enabledFields", "enabledFilters"],

  data() {
    return {
      totalRows: 0,
      periodRef: null,

      bookmark: false,
      branches2: [],
      referenceFilterList: [],

      canAllDelete: false,
      canDeleteFiilals: [],

      tableData: {
        levels: 3,
        columns: [],
        records: [],
        filteredColumns: [],
        activeFilteredColumns: [],
        type: "calculations",
        disabledColumns: [],
        defaultDisabledColumns: [],
        globalFilters: [],
        settingsModal: false,
        actions: true,
        sortedColumn: {
          sortBy: this.$route.query.sortBy ? this.$route.query.sortBy : "date",
          sortType: this.$route.query.sortType ? this.$route.query.sortType : "desc",
        },
      },

      isLoadingTable: false,
      isLoadingData: false,

      manageFiltersModal: null,

      totalPaidProduction: 0,
      totalSumProduction: 0,
      totalPaidDriver: 0,
      totalSumDriver: 0,
      canEdit: true,
      page: 0,

      filters: {
        branches: [],
        branchesReverse: false,
        period: {
          range: "",
          start: "",
          end: "",
        },
        onlyTroubles: false,
        shift: {
          label: "Все",
          value: "all",
        },
      },

      chartsActive: this.$cookies.get("chartsActive") !== "false",
      showCharts: false,

      isLoading: false,
    };
  },

   computed: {
    ...mapGetters("calculations", ["getColumns", "getUserColumns", "saveUserColumns", "getRecords"]),

    branches() {
      return this.$store.getters["references/branches"].map((item) => ({
        label: item.label,
        value: item.id,
      }));
    },

     recordsCount () {
       return Math.max(this.tableData.records.length, 0);
     },

    shifts() {
      const shifts = this.$store.getters["references/shifts"].map((item) => ({
        label: item.label,
        value: item.id,
      }));

      shifts.unshift({
        label: "Все",
        value: "all",
      });

      return shifts;
    },
  },

  watch: {
    "tableData.activeFilteredColumns": function (value) {
      this.refreshTable();
    },

    getColumns(value) {
      const defaultEnabledColumns = [
        "created",
        "filial",
        "creditedToProduction",
        "paidToProduction",
        "creditedToDrivers",
        "paidToDrivers",
        "shift",
        "changed",
        "calcAuthor",
        "totalIncome",
      ];

      this.tableData.defaultDisabledColumns = value
        .filter((column) => !defaultEnabledColumns.includes(column.code))
        .map((column) => column.code);

      this.tableData.filteredColumns = value.filter((column) => column.data_type !== null).map((column) => column.code);

      this.tableData.columns = value.map((item) => {
        let unit = "";
        switch (item.unit) {
          case "ruble":
            unit = ", ฿";
            break;
          case "percent":
            unit = ", %";
            break;
          case "kg":
            unit = ", кг";
            break;
          case "HH:MM":
            unit = ", чч:мм";
            break;
          case "km":
            unit = ", км";
            break;
          default:
            unit = "";
            break;
        }

        return {
          id: item.code,
          created: item.created,
          label: item.short_name + unit,
          unit: item.unit,
          fullName: item.name + unit,
          type: item.data_type ? item.data_type : undefined,
          description: item.description ? item.description : undefined,
          parentColumnId: item.parent_column ? item.parent_column : undefined,
          level: item.level,
          isCategory: item.is_category,
          characteristic: item.characteristic,
        };
      });
    },

    getUserColumns(value) {
      const disabledColumns = this.getColumns.filter((item) => !value.includes(item.code));

      this.tableData.disabledColumns = disabledColumns.map((item) => item.code);
    },

    getRecords(value) {
      if (value === "isExportExcel") return;
      this.totalRows = parseFloat(value.totalRows);


      if ((value === undefined || (Array.isArray(value.items) && value.items.length === 0)) && this.page === 1) {
        this.tableData.records = [];
        this.isDisabledScrollDataLoading = true;
        return;
      }

      if ((value === undefined || (Array.isArray(value.items) && value.items.length === 0)) && this.page !== 1) {
        this.isDisabledScrollDataLoading = true;
        return;
      }

      const currentPageRecords = value.items.map((item) => ({
        id: item.id,
        created: { value: item.created },
        filial: { value: item.filial },
        filial_id: item.filial_id,
        shift: { value: item.shift },
        date: { value: item.is_closed ? `🔒 ${item.date}` : item.date },
        totalIncome: { value: item.totalIncome },
        paidToProduction: { value: item.paidToProduction },
        creditedToDrivers: { value: item.creditedToDrivers },
        creditedToProduction: { value: item.creditedToProduction },
        paidToDrivers: { value: item.paidToDrivers },
        calcAuthor: { value: item.calcAuthor },
        _meta: false,
        isShowRow: true,
        fullName: { value: "" },
      }));

      if ((currentPageRecords && currentPageRecords.length < 30) || (Array.isArray(value) && value.length < 30)) {
        this.isDisabledScrollDataLoading = true;
      }

      this.totalSumProduction = parseFloat(value.totalSumProduction);
      this.totalSumDriver = parseFloat(value.totalSumDriver);
      this.totalPaidDriver = parseFloat(value.totalPaidDriver);
      this.totalPaidProduction = parseFloat(value.totalPaidProduction);

      if (this.page === 1) {
        this.tableData.records = currentPageRecords;
      } else {
        this.tableData.records = this.tableData.records.concat(currentPageRecords);
      }
    },
  },

  async created() {
    this.isLoadingTable = true;

    await this.$store.dispatch("positions/getFilialReference", ['calc']).then((res) => {
      this.branches2 = res.items.map((item) => ({
        label: item.filial_name,
        value: item.id,
      }));
    });

    await this.$store.dispatch("calculations/getPermissions").then((res) => {
      this.canAllDelete = res.canAllDelete;
      this.canDeleteFiilals = res.canDeleteFiilals;
    });

    const str = this.$route.fullPath.split("?")[1];
    const query = queryString.parse(str, { arrayFormat: "index", parseBooleans: true });

    if ("filter" in query) {
      const filters = JSON.parse(query.filter);
      if (filters.period && typeof filters=="object" /*!filters.period.includes("range")*/)
        this.$refs.period.dateValue = filters.period;
      this.filters = filters;
      if (this.filters.branches) {
        this.filters.branches = this.filters.branches.filter((f)=>this.branches2.find((b)=>b.value==f.value))
      }
    } else {
      let sf = localStorage.getItem("calc_filters");
      if (sf && sf!="undefined" && sf!==undefined) {
        const filters = JSON.parse(sf);
        this.filters = filters;
        if (this.filters.branches) {
          this.filters.branches = this.filters.branches.filter((f)=>this.branches2.find((b)=>b.value==f.value))
        }

        if (!filters.period) {
          filters.period = "Последний месяц";
        }
        if (filters.period && typeof filters.period=="string" && !filters.period.includes("range"))
          this.$refs.period.dateValue = filters.period;

        this.$router.push({
          query: {
            filter: JSON.stringify(this.filters),
          },
        });
      }
    }

     this.$store
      .dispatch("calculations/getRecords", [
        this.page,
        this.tableData.sortedColumn.sortBy,
        this.tableData.sortedColumn.sortType,
        { localFilters: [...this.tableData.activeFilteredColumns], globalFilters: this.filters },
      ])
      .then(() => {
        this.tableData.activeFilteredColumnsQueryLocal = this.tableData.activeFilteredColumns.reduce((acc, item) => {
          let currentFilter;
          if (item.type === "list") {
            currentFilter = {
              [item.id]: item.value.map((i) => i.id).join(","),
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "number" && item.searchType === "4") {
            currentFilter = {
              [item.id]: `${item.value.start},${item.value.end}`,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "boolean") {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
            };
          } else {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          }
          return { ...acc, ...currentFilter };
        }, {});

        this.tableData.globalFiltersQueryLocal = this.tableData.globalFilters.reduce((acc, item) => {
          let currentFilter;
          if (item.type === "list") {
            currentFilter = {
              [item.id]: item.value.map((i) => i.id).join(","),
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "number" && item.searchType === "4") {
            currentFilter = {
              [item.id]: `${item.value.start},${item.value.end}`,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "boolean") {
            if (item.value === "1") {
              currentFilter = {
                [item.id]: item.value,
                [`${item.id}_filterType`]: item.type,
              };
            }
          } else {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          }
          return { ...acc, ...currentFilter };
        }, {});

        setTimeout(() => {
          this.$emit("globalFiltersActive");
        }, 400);

        this.showCharts = true;
        this.isLoadingTable = false;
      });

    await this.$store.dispatch("calculations/getColumns").then(() => {
      this.$store.dispatch("calculations/getUserColumns").then(() => {
        setTimeout(() => {
          this.isLoadingTable = false;
        }, 600);
      });
    });
  },

  mounted() {
    this.periodRef = this.$refs.period;
    document.querySelector(".layout").addEventListener("scroll", this.loadMoreRecords);
  },

  methods: {
    setColumnReferenceFilterList(e) {
      const columnId = e.id;

      this.referenceFilterList = this.branches2.map((item) => ({
        id: item.value,
        label: item.label,
        value: item.value,
      }));

    },
    resetFiltersColumns() {
      this.tableData.activeFilteredColumns = []
    },
    onColumnFilterRemove(columnIndex) {
      this.tableData.activeFilteredColumns.splice(columnIndex, 1);
    },
    onSetColumnFilter(filterOptions) {
      this.tableData.activeFilteredColumns.push(filterOptions);
    },
    onSetColumnFilterByIndex(columnIndex, filterOptions) {
      this.tableData.activeFilteredColumns[columnIndex] = filterOptions;
      //this.refreshTable();
    },
    onDisableColumnSortedFlag(columnIndex) {
      this.tableData.columns[columnIndex].isSorted = false;
      this.refreshTable();
    },
    onSortingColumnChange(sortingData) {
      this.tableData.sortedColumn = sortingData;
      this.refreshTable();
    },


    refreshTable() {
      if (!this.isLoadingTable) {
        this.isLoadingTable = true;
        this.isDisabledScrollDataLoading = true;
        this.page = 1;
        this.$store
          .dispatch("calculations/getRecords", [
            this.page,
            this.tableData.sortedColumn.sortBy,
            this.tableData.sortedColumn.sortType,
            { localFilters: [...this.tableData.activeFilteredColumns], globalFilters: this.filters },
          ])
          .then((res) => {
            this.isLoadingTable = false;
            if (res !== undefined && res.items!==undefined && res.items.length === 30) {
              this.isDisabledScrollDataLoading = false;
            }
            const currentQuery = JSON.parse(JSON.stringify(this.$route.query));
            currentQuery.sortBy = this.tableData.sortedColumn.sortBy;
            currentQuery.sortType = this.tableData.sortedColumn.sortType;

            this.$router
              .replace({
                name: "",
                query: currentQuery,
              })
              .catch(() => {});

            this.showCharts = true;
          });
      }
    },

    loadMoreRecords() {
      const layout = document.querySelector(".layout");
      const isScrollable = layout.scrollHeight > layout.clientHeight;

      const scroll = Math.round(layout.scrollTop);
      const height = layout.scrollHeight - layout.clientHeight;

      if (
        isScrollable &&
        scroll === height &&
        !this.isLoadingData &&
        !this.isDisabledScrollDataLoading &&
        !this.isLoadingTable
      ) {
        this.isLoadingData = true;
        this.page += 1;

        this.$store
          .dispatch("calculations/getRecords", [
            this.page,
            this.tableData.sortedColumn.sortBy,
            this.tableData.sortedColumn.sortType,
            { localFilters: [...this.tableData.activeFilteredColumns], globalFilters: this.filters },
          ])
          .finally(() =>
            setTimeout(() => {
              this.isLoadingData = false;
            }, 300),
          );
      }
    },


    toggleCharts() {
      this.chartsActive = !this.chartsActive;
      Vue.$cookies.set("chartsActive", this.chartsActive);
    },

    setLevelsDataTable(levelsCount) {
      this.tableData.levels = levelsCount;
    },

    submitTableSettings(disabledColumns) {
      let enabledColumns = this.getColumns.filter((item) => !disabledColumns.includes(item.code));

      enabledColumns = enabledColumns.map((item) => item.code);

      this.$store.dispatch("calculations/saveUserColumns", enabledColumns);
    },

    submitFilters() {
      if (this.$route.query.filter !== JSON.stringify(this.filters)) {
        localStorage.setItem("calc_filters", JSON.stringify(this.filters));
        this.showCharts = false;
        this.refreshTable();
        this.$router.push({
          query: {
            filter: JSON.stringify(this.filters),
          },
        });
      }
    },

    applyFilters(query) {
      if (this.$route.query.filter !== query) {
        this.$router.push({
          query: {
            filter: query,
          },
        });
        this.filters = JSON.parse(query);
        //localStorage.setItem("calc_list_filters", query);
      }
    },

    resetFilters() {
      this.filters = {
        branches: [],
        branchesReverse: false,
        period: "",
        onlyTroubles: false,
        shift: {
          label: "Все",
          value: "all",
        },
      };
      this.filters.period = "";
      this.filters.period = null;
      this.$refs.period.periodReset();
      if (Object.keys(this.$route.query).length !== 0) {
        this.$router.push({
          query: {},
        });
      }

      this.refreshTable();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.calculations {
  padding: 33px 30px 30px 30px;

  @media screen and (max-width: 1000px) {
    padding: 33px 30px 30px 30px;
  }

  @media screen and (max-width: 700px) {
    padding: 20px;
  }

  &__filters {
    &-troubles {
      margin-bottom: 4px;
    }

    &-item {
      margin-bottom: 30px;

      &-switcher {
        margin-top: 20px;
      }
    }

    &-actions {
      width: 100%;
      display: flex;
      justify-content: flex-end;

      &-item {
        margin-left: 10px;

        &:first-child {
          margin-left: 0;
        }
      }

      @media screen and (max-width: 767px) {
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: -1rem;

        &-item {
          margin-left: 0;
          margin-bottom: 1rem;
          width: calc(50% - 7px);

          ::v-deep & .c-button__wrapper {
            justify-content: center;
            width: 100%;
          }

          &-apply {
            order: 3;
          }
        }
      }
    }

    &-col {
      & .c-switcher-width-inherit {
        width: auto;
        ::v-deep & .c-switcher {
          margin-bottom: 0;
        }
      }
    }
  }

  &__actions {
    &__new-calc-desktop {
      @media screen and (max-width: 700px) {
        display: none;
      }
    }

    &__new-calc-mobile {
      display: none;

      @media screen and (max-width: 700px) {
        display: block;
      }
    }
  }

  &__content {
    padding-top: 10px;
  }

  &__settings {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-bottom: 19px;
    margin-top: 7px;

    @media (max-width: 1519px) {
      flex-direction: column;
    }
  }

  &__summary {
    display: flex;
    background: $color-bg;
    height: 30px;
    border-radius: 15px;
    padding: 0 20px;
    align-items: center;

    @media (max-width: 1519px) {
      justify-content: center;
      margin-bottom: 20px;
    }

    @media screen and (max-width: 992px) {
      margin-bottom: 0;
    }

    @media (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
      height: auto;
      margin: 0 -30px;
      margin-top: -20px !important;
      padding: 7px 20px;
      border-radius: 0;
    }

    @media screen and (max-width: 700px) {
      margin: 0 -20px;
    }

    &-item {
      font-size: 13px;
      color: $color-label;
      margin-left: 14px;

      &:first-child {
        margin-left: 0;
      }

      @media (max-width: 767px) {
        margin-left: 0;
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      span {
        color: black;
        font-weight: 500;
      }
    }
  }

  &__charts {
    margin: -14px 0;

    &-wrapper {
      opacity: 0;
      max-height: 0;
      visibility: hidden;
      transition: max-height 0.3s ease-out;

      &_active {
        max-height: 1000px;
        height: auto;
        opacity: 1;
        visibility: visible;
        transition: max-height 0.4s ease-out;
      }

      &-hr-top {
        margin: 0 0 17px 0;
      }

      &-hr-bottom {
        margin: 16px 0 20px 0;
      }
    }
  }

  &__actions {
    display: flex;

    &-item {
      margin-left: 10px;

      @media (max-width: 992px) {
        margin-top: 20px;
      }

      &:first-child {
        margin-left: 0;
      }
    }

    @media (max-width: 1519px) {
      justify-content: flex-end;
    }
  }
}

::v-deep .highcharts-contextmenu {
  top: 5px !important;
}

::v-deep .highcharts-exporting-group {
  cursor: pointer;
}

::v-deep .c-input-container_period {
  @media screen and (max-width: 991px) {
    transform: none !important;
    right: -30px !important;
    left: auto !important;
  }

  @media screen and (max-width: 767px) {
    right: 0 !important;
  }
}
</style>
<style>
.c-table__cell_created .c-table__cell-value {
  white-space: nowrap;
}

</style>
